import React from 'react';
import download from '@/utils/downloads';
import { states } from '@/constants/lifecycle';
import DownloadAction from '@/components/ribbon-actions/DownloadAction';
import RefreshActionMenu from '@/components/ribbon-actions/RefreshActionMenu';
import DatasetAction from '../../components/DatasetAction';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const DatasetMarkdownActions = ({ category, code }) => {
  const {
    allowDownload, allowRead, allowRefresh, readStatus, text,
  } = Selectors.useDatasetMarkdownActions({ category, code });
  const fetchData = Events.useFetchDatasetMarkdown(category, { code });

  return (
    <>
      {allowRead && (<DatasetAction code={code} />)}
      {allowRefresh && (<RefreshActionMenu onClick={fetchData} readStatus={readStatus} />)}
      {allowDownload && (
        <DownloadAction
          disabled={readStatus !== states.SUCCESS}
          onClick={() => download.textDownload(text, `${code}_dataset.md`)}
        />
      )}
    </>
  );
};

export default DatasetMarkdownActions;
